module.exports = {
  // 成员页
  JCRing_member: {
    //首页
    index1: "成員健康",
    index2: "健康群組",
    index3: "個成員",
    index4: "添加群組",
    index5: "加入的群組",
    index6: "預警設置",
    index7: "讓關心你健康的人更加關心你跨越距離，關愛更及時",
    index8: "暫未加入群組",
    index9: "消息中心",
    index10: "通過/手機/郵箱/二維碼/微信邀請加入",

    //創建群組
    addgroup1: "群組名稱",
    addgroup2: "群組類型",
    addgroup3: "請填寫群組名稱",
    addgroup4: "家庭群組",
    addgroup5: "公司群組",
    addgroup6: "其他群組",
    addgroup7: "醫療群組",
    addgroup8: "學校群組",
    addgroup9: "確定",
    addgroup10: "取消",
    addgroup11: "立即創建",
    addgroup12: "群組名已經存在",

    //成員列表
    memberlist1: "成員列表",
    memberlist2: "有",
    memberlist3: "項異常",
    memberlist4: "正常",
    memberlist5: "添加成員",
    memberlist6: "解散",
    memberlist7: "暫無成員",
    memberlist8: "載入中...",
    memberlist9: "是否解散此群？",
    memberlist10: "解散成功",
    memberlist11: "保存成功",
    memberlist12: "修改群組資訊",
    memberlist13: "解散群組",
    memberlist14: "健康概覽",
    memberlist15: "項正常",
    memberlist16: "項異常",
    memberlist17: "點擊查看",
    memberlist18: "昨日無數據",
    memberlist19: "昨日",
    memberlist20: "已發出",
    memberlist21: "條群組邀請，待確認",

    //修改成員
    updatemember1: "頭像",
    updatemember2: "更換",
    updatemember3: "原昵稱",
    updatemember4: "修改昵稱",

    //健康資料
    healthdata1: "的健康資料",
    healthdata2: "健康資料",
    healthdata3: "周日",
    healthdata4: "週一",
    healthdata5: "週二",
    healthdata6: "週三",
    healthdata7: "週四",
    healthdata8: "週五",
    healthdata9: "週六",
    healthdata10: "心率",
    healthdata11: "心率變異性",
    healthdata12: "收縮壓",
    healthdata13: "舒張壓",
    healthdata14: "體溫變化",
    healthdata15: "血氧飽和度",
    healthdata16: "睡眠",
    healthdata17: "壓力",
    healthdata18: "膽固醇",
    healthdata19: "甘油三酯",
    healthdata20: "低密度脂蛋白膽固醇",
    healthdata21: "高密度脂蛋白膽固醇",
    healthdata22: "血糖",
    healthdata23: "餐前",
    healthdata24: "餐後",
    healthdata25: "最大攝入氧量",
    healthdata26: "呼吸",
    healthdata27: "步數",
    healthdata28: "步",
    healthdata29: "卡路里",
    healthdata30: "千卡",
    healthdata31: "距離",
    healthdata32: "千米",
    healthdata33: "配速",
    healthdata35: "秒/公里",
    healthdata36: "分",
    healthdata37: "正在載入健康資料",
    healthdata38: "運動資料",
    healthdata39: "預警",
    healthdata40: "未授權",
    healthdata41: "修改成員資訊",
    healthdata42: "刪除成員",
    healthdata43: "郵箱：",
    healthdata44: "手機：",
    healthdata45: "是否刪除此成員？",
    healthdata46: "未來日期無法顯示",
    healthdata47: "今天",

    //邀請成員
    addmember1: "邀請成員",
    addmember2: "添加成員帳戶",
    addmember4:
      "通過“成員帳戶”可讓你查看成員健康資料和設置預警資料範圍，更好的關注成員健康",
    addmember5: "瞭解詳情",
    addmember6: "健康群組成員",
    addmember7: "邀請",
    addmember8: "加入",
    addmember9: "掃碼邀請",
    addmember10: "微信邀請",
    addmember11: "通過掃二維碼邀請加入群組",
    addmember12: "通過微信邀請加入群組",
    addmember13: "手機號/郵箱邀請",
    addmember14: "通過手機號/郵箱邀請加入群組",
    addmember15: "邀請成員加入，可以瞭解成員健康狀況",
    addmember16: "發送邀請",
    addmember17: "已發送",
    addmember18: "對方待確認",
    addmember19: "我已加入",
    addmember20: "立即分享",
    addmember21: "保存圖片",
    addmember22: "我已拒絕",
    addmember23: "我已退出",
    addmember24: "對方已退出",
    addmember25: "對方已拒絕",
    addmember26: "對方已加入",
    addmember27: "其它添加方式",

    // 群組二維碼
    code1: "群組二維碼",
    code2: "健康管理群",
    code3: "該二維碼5分鐘內有效，請及時使用",

    //群組邀請
    invide1: "群組邀請",
    invide2: "成員健康",
    invide3: "邀請你加入群組...",
    invide4: "加入該群組",
    invide5: "為了您的資料安全，建議在加入群組前核查群組資訊",
    invide6: "加入群組後，您將授權關注者可以查看您的健康資料 ",

    //分享健康資料設置
    sethealthdata1: "健康數據設置",
    sethealthdata2: "確定",
    sethealthdata3: "請設置昵稱",
    sethealthdata4: "全部允許",
    sethealthdata5: "設置昵稱",
    sethealthdata6: "保存",
    sethealthdata7: "請輸入",
    sethealthdata8: "請上傳圖片格式",
    sethealthdata9: "請設置昵稱和頭像",
    sethealthdata10: "請設置頭像",
    sethealthdata11: "昵稱長度為1-8個字元",
    // 設置數據區間
    setscope1: "心率上下限區間",
    setscope2: "體溫上下限區間",
    setscope3: "睡眠上下限區間",
    setscope4: "胎心上下限區間",
    setscope5: "餐前血糖",
    setscope6: "餐後血糖",
    setscope7: "血氧上下限區間",
    setscope8: "男性尿酸",
    setscope9: "女性尿酸",
    setscope10: "收縮壓",
    setscope11: "舒張壓",
    setscope12: "上限",
    setscope13: "下限",
    setscope14: "預警設置",
    setscope15: "設置成功",
    setscope16: "上限",
    setscope17: "下限",
    setscope18: "預警",

    //下載頁
    onload1: "點擊",
    onload2: "加入健康群組",
    onload3: "請用流覽器打開",
    onload4: "知道了",
    onload5: "友宏健康 智享健康每一天",
    onload6: "appstore免費下載",
    onload7: "免費下載",
    onload8: "連結已失效",
    onload9: "二維碼已失效",
    onload10: "加入成功",

    // （消息中心）待處理
    pending1: "同意",
    pending2: "拒絕",
    pending3: "重新發送邀請",
    pending4: "暫無數據",
    pending5: "邀請已發送，等待用戶同意邀請",
    pending6: "確認",
    pending7: "退出",

    guide1: "進入成員健康後，需要先創建相應類型的群組。",
    guide2:
      "創建群組後，進入群組中，可以查看用戶的健康概覽，也可以邀請新成員進入群組。",
    guide3:
      "群組中邀請新成員，可通過掃碼，微信，手機號/郵箱等方式邀請。新成員加入群組後，您可查看TA每天的健康動態。",
    guide4: "點擊查看健康概覽，可以查看成員的健康資料，並可判斷正常與異常。",
    guide5: "下一步",
    guide6: "完成",
    guide7: "超過預警值",

    invite1: "通過手機號/郵箱邀請",
    invite2: "請輸入帳號",
    invite3: "請輸入手機號",
    invite4: "請輸入郵箱",
    invite5: "請輸入正確的手機號",
    invite6: "請輸入正確的郵箱",
    invite7: "已加入該群組",
    invite8: "用戶不存在",
    invite9: "請選擇國家或地區",
    invite10: "請輸入搜索關鍵字",
    invite11: "確認用戶",
    invite12: "邀請TA",
    invite13: "請選擇"
  },

  // AI H5页面
  JCRingAI: {
    // 總指數模組
    index: "您好,",
    index1: "以下是您的AI健康週報告分析。",
    index2: "周",
    index3: "月",
    index4: "均健康指數",
    index5: "均睡眠指數",
    index6: "均活力指數",
    index7: "均平衡指數",
    index8: "日",
    index9: "年",
    index10: "周數據趨勢報告",
    index11: "月數據趨勢報告",
    index12: "以下是您的AI健康月報告分析。", // 睡眠模組

    sleep: "睡眠恢復",
    sleep1: "您的周睡眠指數趨勢",
    sleep2: "您的月睡眠指數趨勢",
    sleep3:
      "睡眠指數是作為您判斷睡眠健康狀況的一個指標，它根據您的總睡眠時長、睡眠效率、入睡用時、睡眠心率、睡眠血氧、睡眠心率變異性等多項指標計算出的睡眠指數。",
    sleep4: "周平均睡眠指數為",
    sleep5: "周睡眠概覽",
    sleep6: "平均睡眠時長為",
    sleep7: "睡眠分區",
    sleep8: "平均時長",
    sleep9: "平均占比",
    sleep10: "睡眠總占比",
    sleep11: "零星小睡",
    sleep12: "清醒",
    sleep13: "快速眼動",
    sleep14: "淺睡",
    sleep15: "深睡",
    sleep16: "占周總時間的",
    sleep17: "周總睡眠時長",
    sleep18: "周平均睡眠效率為",
    sleep19: "%，平均入睡用時為",
    sleep20: "min",
    sleep21: "睡眠分析", // 月睡眠模組

    sleep22: "您提升的睡眠數據",
    sleep23: "睡眠指數",
    sleep24: "比上周",
    sleep25: "月平均睡眠指數為",
    sleep26: "睡眠時長",
    sleep27: "入睡時間",
    sleep28: "月平均入睡為",
    sleep29: "您需要提升的方面",
    sleep30: "睡眠效率",
    sleep31: "月睡眠效率為",
    sleep32: "如何提高睡眠效率？",
    sleep33: "月睡眠報告", // 活力消耗

    Expend: "活力與能量消耗",
    Expend1: "您的周活力指數趨勢",
    Expend2: "您的月活力指數趨勢",
    Expend3:
      "活力指數的是作為您判斷運動狀況的一個指標，它根據您的每日步數、距離、卡路里、運動量等多項指標計算出的活力指數。",
    Expend4: "周平均活力指數為",
    Expend5: "周活力概覽",
    Expend6: "平均步數為",
    Expend7: "，平均距離為",
    Expend8: "公里，卡路里為",
    Expend9: "千卡",
    Expend10: "類型/日期",
    Expend11: "步數",
    Expend12: "卡路里",
    Expend13: "距離",
    Expend14: "步數目標完成天數為",
    Expend15: "，卡路里目標完成天數為",
    Expend16: "，距離目標完成天數為",
    Expend17: "活力分析", // 月活力消耗
    Expend18: "活力指數",
    Expend19: "月平均活力指數為",
    Expend20: "平均步數",
    Expend21: "月平均步數為",
    Expend22: "平均卡路里",
    Expend23: "月平均卡路里為",
    Expend24: "千卡",
    Expend25: "平均距離",
    Expend26: "月平均距離為",
    Expend27: "公里",
    Expend28: "如何提高活力數據？",
    Expend29: "月活力報告", // 壓力

    Pressure: "壓力與平衡",
    Pressure1: "您的周平衡指數趨勢",
    Pressure2: "您的月平衡指數趨勢",
    Pressure3:
      "平衡指數的是作為您判斷壓力狀況的一個指標，它根據您的每日壓力、HRV、應激反應、恢復指數等多項指標計算出的活力指數。",
    Pressure4: "平均活力指數為",
    Pressure5:
      "平衡指數總體保持穩定，但波動幅度較大，可能與你的情緒狀態波動有關。建議學習一些壓力管理技巧，例如冥想、深呼吸等，以調節情緒，保持身心健康。",
    Pressure6: "平衡概覽",
    Pressure7: "平均壓力為",
    Pressure8: "，平均應激反應為",
    Pressure9: "，平均恢復指數為",
    Pressure10: "壓力",
    Pressure11: "應激反應",
    Pressure12: "恢復指數",
    Pressure13: "平衡分析", // 月壓力
    Pressure14: "您提升的平衡數據",
    Pressure15: "平衡指數",
    Pressure16: "月應急反應為",
    Pressure17: "平均壓力",
    Pressure18: "月平均壓力為",
    Pressure19: "如何降低壓力數據？",
    Pressure20: "月壓力與平衡報告", // 心率血氧血糖模組

    Health: "健康概覽",
    Health1: "您的周心率趨勢",
    Health2: "平均心率為",
    Health3: "bpm",
    Health4: "您的周血氧趨勢",
    Health5: "周平均血氧為",
    Health6: "您的周血糖風險",
    Health7: "周血糖測量",
    Health8: "天",
    Health9: ["週一", "週二", "週三", "週四", "週五", "週六", "周日"], // 月心率血氧血糖模組

    Health10: "您的正常健康數據",
    Health11: "平均心率",
    Health12: "月平均心率為",
    Health13: "平均血氧",
    Health14: "月平均血氧為",
    Health15: "您的異常健康數據",
    Health16: "平均HRV",
    Health17: "月平均HRV為",
    Health18: "ms",
    Health19: "如何提高HRV？",
    
  
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh_hk.js